import { useEffect, useState } from "react";
import Icon from "@mui/material/Icon";
import axios from "axios";
import { API_URL } from "config";

const LoginApprovalBadgeIcon = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let active = true;
    const token = localStorage.getItem("authToken");

    const fetchCount = async () => {
      try {
        const res = await axios.get(`${API_URL}/login-approval-notifications/count`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (active) setCount(Number(res.data?.count || 0));
      } catch {
        if (active) setCount(0);
      }
    };

    fetchCount();

    return () => {
      active = false;
    };
  }, []);

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <Icon>notifications</Icon>
      {count > 0 && (
        <span
          style={{
            position: "absolute",
            top: -6,
            right: -6,
            background: "red",
            color: "white",
            borderRadius: "50%",
            padding: "4px 6px",
            fontSize: 10,
          }}
        >
          {count}
        </span>
      )}
    </div>
  );
};

export default LoginApprovalBadgeIcon;
